import {instance, onErrorFunction} from "../../config/axios-cnf";
import {USER_SET_TOKEN} from "../../reducers/user";

export const apiLogout = (callback, error) => {
    instance.get("/api/v1/user/logout")
        .then(response => callback(response.data))
        .catch(err => error(err))
}

export const apiAuthorizate = (callback, error) => {
    instance.get("/api/v1/user/auth")
        .then(response => callback(response.data))
        .catch(err => error(err))
}

export const apiLoginUser = (values, callback, error) => {
    instance.post("/api/v1/user/login", values)
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}

export const apiSendForgotPassword = (values, callback, error) => {
    instance.post("/api/v1/user/forgot-password", values)
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}

export const apiGetForgotPasswordPage = (code, callback, error) => {
    instance.get("/api/v1/user/forgot-password",{params:{code}})
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}

export const apiChangeForgotPassword = (values, callback, error) => {
    instance.put("/api/v1/user/forgot-password", values)
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}

export const apiConfirmAccount=(code,callback,error)=>{
    instance.get("/api/v1/user/confirm-account/"+code)
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}

export const apiResendConfirmAccount=(email,callback,error)=>{
    instance.post("/api/v1/user/resend-confirm-account",{email:email})
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}
export const axiosSetAuthorizationToken = (token, dispatch) => {
    instance.defaults.headers.common["Authorization"] = token;
    localStorage.setItem("authorization-leg-enigoo", token)
    dispatch({type: USER_SET_TOKEN, payload: token})
}

export const axiosDeleteAuthorizationToken = () => {
    instance.defaults.headers.common["Authorization"] = null;
    localStorage.removeItem("authorization-leg-enigoo")
}


export const getTokenFromLocalStorage = (dispatch) => {
    let token = localStorage.getItem('authorization-leg-enigoo')
    if (token === null || token === 'undefined') return false;
    axiosSetAuthorizationToken(token, dispatch)
}






